// TODO: migrate to ts
import dayjs from "dayjs"
import _ from "lodash"

// TODO: replace `TEMP_GROUP_MULTIPLE_LOCATIONS` with `groupMultipleLocations` from app config
const TEMP_GROUP_MULTIPLE_LOCATIONS = false

/**
 * NOTE:
 * - if `TEMP_GROUP_MULTIPLE_LOCATIONS` is true, group occupants data by `properties.name.en` if duplicate name store in locations and add `hasMultipleLocations` property
 * - if `TEMP_GROUP_MULTIPLE_LOCATIONS` is false, return the original data
 */
export const uniqueOccupantByName = (data = {}, newShopConfig) => {
  const { pages = [] } = data

  const currentDate = dayjs()
  const periodInDays = newShopConfig?.periodInDays ?? 30

  return {
    ...data,
    pages: pages.map((page) =>
      TEMP_GROUP_MULTIPLE_LOCATIONS
        ? {
            ...page,
            data: _(page?.data || [])
              .groupBy("properties.name.en")
              .map((locations) => {
                const firstRecord = locations[0]
                const hasMultipleLocations = locations.length > 1

                const startDate = dayjs(firstRecord.properties?.start_date)
                const isNewShop =
                  currentDate.isSameOrAfter(startDate) &&
                  currentDate.diff(startDate, "day") <= periodInDays
                const isComingSoon = startDate.isAfter(currentDate)

                return {
                  ...firstRecord,
                  properties: {
                    ...firstRecord.properties,
                    hasMultipleLocations,
                    isNewShop,
                    isComingSoon,
                    startDate,
                  },
                }
              })
              .value(),
          }
        : {
            ...page,
            data: _(page?.data || [])
              .map((locations) => {
                const startDate = dayjs(locations.properties?.start_date)
                const isNewShop =
                  currentDate.isSameOrAfter(startDate) &&
                  currentDate.diff(startDate, "day") <= periodInDays
                const isComingSoon = startDate.isAfter(currentDate)

                return {
                  ...locations,
                  properties: {
                    ...locations.properties,
                    isNewShop,
                    isComingSoon,
                    startDate,
                  },
                }
              })
              .value(),
          }
    ),
  }
}
